import React from "react";
import {
	IconButton,
	Dropdown,
	DropdownMenuButton,
} from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";
import { getLegacyCheckboxes } from "data/app/appSelectors";
import { useSelector } from "react-redux";

interface Props {
	uuid: string;
	row: {
		index: number;
	};
	disabled: boolean;
	editRow: (index?: number | undefined) => void;
	setActiveRow: React.Dispatch<React.SetStateAction<number | null>>;
	handleRemove: () => void;
}

const LegacyDropdown = ({
	uuid,
	row,
	disabled,
	editRow,
	setActiveRow,
	handleRemove,
}: Props) => {
	const { t } = useTranslation();
	const checkboxes = useSelector(getLegacyCheckboxes)[uuid] || [];

	return (
		<div className="legacyArrayView-actions">
			<Dropdown
				id={`${uuid}_menu_${row.index}`}
				align="right"
				disabled={disabled}
				menuBtn={
					<IconButton
						icon="ellipsis-v"
						label={t("main.labels.menu")}
						className="btn-basic--default btn--round"
					/>
				}>
				<DropdownMenuButton
					label={
						checkboxes.length && checkboxes.includes(row.index)
							? `${t("common.labels.edit")} (${
									checkboxes.length
							  })`
							: t("common.labels.edit")
					}
					onClick={() => {
						checkboxes.length && checkboxes.includes(row.index)
							? editRow()
							: editRow(row.index);
					}}
				/>
				<DropdownMenuButton
					label={
						checkboxes.length && checkboxes.includes(row.index)
							? `${t("common.labels.delete")} (${
									checkboxes.length
							  })`
							: t("common.labels.delete")
					}
					onClick={() => {
						setActiveRow(row.index);
						handleRemove();
					}}
				/>
			</Dropdown>
		</div>
	);
};

export default React.memo(LegacyDropdown);
